import { FC } from 'react'
import { Icon, IconType, Menu } from '@lmc/ui-kit'
import styled from 'styled-components'
import { ConfigProvider } from 'antd'
import {
  CustomMenuItemType,
  getNavigationMenuItems,
  navigationTheme,
} from 'utils'
import { useRouter } from 'hooks/useRouter'

const getNavItems = () => {
  return [
    {
      url: '/group-reports',
      label: 'BMI',
      icon: (
        <Icon customIcon={IconType.GroupsBMIIcon} style={{ fill: 'none' }} />
      ),
    },
    {
      url: '/group-reports/todos',
      label: 'To-Do’s',
      icon: (
        <Icon customIcon={IconType.GroupsToDosIcon} style={{ fill: 'none' }} />
      ),
    },
    {
      url: '/group-reports/incidents',
      label: 'Incidents',
      icon: <Icon customIcon={IconType.ReportsIncidents} />,
      subItems: [
        {
          url: '/group-reports/incidents/list',
          label: 'Incidents list',
        },
        {
          url: '/group-reports/incidents',
          label: 'Incidents per month',
        },
      ],
    },
    {
      url: '/group-reports/care-plans',
      label: 'Care Plans',
      icon: (
        <Icon customIcon={IconType.SidePlanning} style={{ fill: 'none' }} />
      ),
    },

    {
      url: '/group-reports/download-centre',
      label: 'Download Centre',
      icon: (
        <Icon customIcon={IconType.DownloadIcon} style={{ fill: 'none' }} />
      ),
    },
    {
      url: '/group-reports/goals-overview',
      label: 'Goals Overview',
      icon: (
        <Icon customIcon={IconType.ReportsGoals} style={{ fill: 'none' }} />
      ),
    },
  ] as unknown as CustomMenuItemType[]
}

const GroupsSidebarNavigation: FC = () => {
  const { navigate, location } = useRouter()

  const navigationKey = location.pathname

  const items = getNavigationMenuItems(getNavItems())

  return (
    <StyledContainer>
      <StyledMenuContainer>
        <ConfigProvider theme={navigationTheme}>
          <Menu
            onClick={({ key }) => navigate(`${key}`)}
            style={{ border: 'none' }}
            selectedKeys={[navigationKey]}
            mode="inline"
            theme="light"
            inlineCollapsed={false}
            items={items}
            defaultOpenKeys={['/group-reports/incidents']}
          />
        </ConfigProvider>
      </StyledMenuContainer>
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  margin-bottom: 0px;
  background-color: ${(props) => props.theme.color?.neutral.color11} !important;
  max-width: 290px;
  width: 290px;
  height: 100%;
`

const StyledMenuContainer = styled.div`
  max-height: calc(100vh - 64px);
  overflow-y: auto;
  ${({ theme }) => theme.mediaQueries?.mobileDown} {
    max-height: unset;
  }
`

export default GroupsSidebarNavigation
